import { NgModule } from '@angular/core';
import { FiltroPipe } from './filtro.pipe';



@NgModule({
  declarations: [
    FiltroPipe
  ],
  imports: [
  ],
  exports:[
    FiltroPipe
  ]
})
export class PipesModule { }
